import './App.scss';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Home } from './home/home';
import { Room } from './rooms/rooms';
import { AboutUs } from './about-us/about-us';
import { ViewGallery } from './rooms/rooms-intro/view-gallery/view-gallery';
import BookNow from './book-now/book-now';
import ContactUs from './contact-us/contact-us';
import Header from './header';
import { RoomsInfo } from './rooms/rooms-info';

function App() {

  const navigate = useNavigate();
  const location = useLocation();
  const [carouselList, setCarouselList] = useState([]);
  const [showGallery, setShowGallery] = useState(false);

  // prepare the flattened carousel list once on mount
  useEffect(() => {
    const imagesList = RoomsInfo.map(info => info.carouselImages || []);
    const flattened = [];
    imagesList.forEach(images => flattened.push(...images));
    setCarouselList(flattened);
  }, []);

  // when navigating to /gallery, ensure the gallery is shown
  useEffect(() => {
    if (location.pathname === '/gallery') {
      setShowGallery(true);
    } else {
      setShowGallery(false);
    }
  }, [location.pathname]);

  // helper to open gallery and navigate
  function openGallery() {
    setShowGallery(true);
    navigate('/gallery');
  }

  function closeGallery() {
    setShowGallery(false);
    // go back one step when closing (adjust as needed)
    navigate(-1);
  }

  return (
    <div>
      <Header />
      <div className='body'>
        <Routes>
          <Route path='/' element={<Navigate to="/home" replace />} />
          <Route path='/home' element={
            <>
              <Home />
            </>
          }
          />
          <Route path='/rooms' element={
            <>
              <Room />
            </>
          }
          />
          <Route path='/gallery' element={
            <>
              <ViewGallery show={true} imagesList={carouselList} handleClose={() => closeGallery()} />
            </>
          }
          />

          <Route path='/book-now' element={
            <>
              <BookNow />
            </>
          }
          />
          <Route path='/about-us' element={
            <>
              <AboutUs />
            </>
          }
          />
          <Route path='/contact-us' element={
            <>
              <ContactUs />
            </>
          }
          />
          <Route path='*' element={<Navigate to="/home" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
